import { TableRowSkeleton } from '@/shared/ui/table/table-row-skeleton';

export function ClientTableSkeleton({ rows = 5 }: { rows?: number }) {
    return (
        <div className="flex-1 overflow-auto min-h-0 flex flex-col">
            {Array.from({ length: rows }).map((_, idx) => (
                <TableRowSkeleton key={idx} />
            ))}
        </div>
    );
}
